import React, { useEffect, useState } from 'react'
import { GetHeatName } from './ResultStage'
import { RaceDTO } from '../../../interfaces/RaceDTO';
import moment from 'moment';
import { eventBus } from '../../../services/eventHandler';
import { LevelStatusEnum } from '../../../interfaces/LevelsDTO';

interface Props{
    classid:number | null;
    level: number;
    race: RaceDTO;
    backgroundColor: string;
}

const ResultStageHeader = ({classid,level,race,backgroundColor}:Props) => {
    const [levelStatus,setLevelStatus] = useState<LevelStatusEnum>(LevelStatusEnum.ReadyForStart);
    // const [backgroundColor,setBackgroundColor] = useState<string>("");

   
    const fixStarttime = (clsid:number | null,lvl:number):string => {
        if (clsid){
            if (lvl in race.Class[clsid].Level){
                return race.Class[clsid].Level[lvl].StartTime ? moment(race.Class[clsid].Level[lvl].StartTime).format("HH:mm:ss") : "";
            }
            // console.log(race.Class[clsid].Level[lvl]);
            return "";
        }

        return "";
    };
  return (
    <div className="stage-heat-header" style={{fontSize: "15px", background: backgroundColor}}>
                        <span style={{display: "inline-block",fontWeight: "400"}}>{GetHeatName(level)}</span>
                        <span style={{display: "inline-block", float:"right", paddingRight: "5px",fontWeight: "400",transform: "unset"}}>{fixStarttime(classid,level)}</span>
                    </div>
  )
}

export default ResultStageHeader